/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnitMeasurmentEnumTypesDto as DigiworkMaitreDPosDtoEnumTypesUnitMeasurmentEnumTypesDto } from '../../models/Digiwork/MaitreD/Pos/DTO/EnumTypes/unit-measurment-enum-types-dto';

export interface GetMeasurementUnitTypes$Params {
}

export function getMeasurementUnitTypes(http: HttpClient, rootUrl: string, params?: GetMeasurementUnitTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoEnumTypesUnitMeasurmentEnumTypesDto>> {
  const rb = new RequestBuilder(rootUrl, getMeasurementUnitTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoEnumTypesUnitMeasurmentEnumTypesDto>;
    })
  );
}

getMeasurementUnitTypes.PATH = '/api/stock-items/measurement-units';
